import React, {Component} from 'react';
import Spinner from '../generic/spinner';
import Parse from "parse";
import Api from "../../Utils/api";
import Utils from "../../Utils/Utility";


export default class LocationConfig extends Component {

    static contextTypes = {
        router: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {
            fields: {},
            errors: {},
            isLoaded: true,
            activeLocation:null
        }

        this._bind(
            // 'getLocationDetailWithPvtConfig'
            'updatePhoneNumber'
        );
    }

    _bind(...methods) {
        methods.forEach((method) => this[method] = this[method].bind(this));
    }

    componentDidMount() {

        // this.getLocationDetailWithPvtConfig();

    }

    componentWillMount() {

        this.setState({
            activeLocation: this.props.activeLocation
        },()=>{
            this.loadLocationConfig();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps !== null && nextProps.isLoaded == true) {
            this.setState({
                    activeLocation: nextProps.activeLocation
                },
                () => {
                    this.loadLocationConfig();
                });
        }
    }

    loadLocationConfig() {
        const { activeLocation } = this.state;

        if (!Utils.isEmptyObj(activeLocation)) {
            const formattedPhoneNumber = Utils.formatPhoneNumber(activeLocation.phoneNumber);

            this.setState({
                fields: {
                    name: activeLocation.name || "",
                    taxes: activeLocation.taxes || "",
                    desc: activeLocation.desc || "",
                    addLine1: activeLocation.addLine1 || "",
                    addLine2: activeLocation.addLine2 || "",
                    state: activeLocation.state || "",
                    city: activeLocation.city || "",
                    zipCode: activeLocation.zipCode || "",
                    phoneNumber: formattedPhoneNumber || "",
                    url: activeLocation.url || ""
                }
            });
        }
    }


    handleChange(field, e){

        let fields = this.state.fields;
        fields[field] = e.target.value;

        let statusValue = e.target.value;

        this.setState({fields, errors: {}});
    }

    updateTaxValue(field, e) {
        const fieldValue = e.target.value;

        // Only allow numbers by filtering out non-numeric characters
        const numericValue = fieldValue.replace(/[^\d.]/g, '');

        // Update state with the sanitized numeric value
        this.setState(prevState => ({
            fields: {
                ...prevState.fields,
                [field]: numericValue
            },
            errors: {}
        }));
    }

    updatePhoneNumber(event) {
        const { value } = event.target;
        const formattedNumber = Utils.formatPhoneNumber(value);

        // Update state using functional setState for better concurrency
        this.setState(prevState => ({
            ...prevState,  // Spread the previous state
            fields: {
                ...prevState.fields,  // Spread the previous fields
                phoneNumber: formattedNumber  // Update phoneNumber field with formatted number
            },
            errors: {}  // Clear errors
        }));
    }

    removeNonNumber(value){
        // Remove all non-numeric characters using a regular expression
        return value.replace(/\D/g, '');
    }

    formatPhoneNumber(phoneNumber) {
        // Format phone number as needed
        // Example: (123) 456-7890
        return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    }

    handleKeyPress(event) {
        const allowedKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace'];
        if (!allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    }

    handleValidation(){

        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;

        if (Utils.isEmpty(fields["name"])) {
            formIsValid = false;
            errors["name"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("locationInputBox");
            });
            return formIsValid;
        }

        if (fields["taxes"] === "" || parseFloat(fields["taxes"]) < 0) {
            formIsValid = false;
            if (fields["taxes"] === "") {
                errors["taxes"] = "Cannot be empty";
            } else {
                errors["taxes"] = "Value cannot be negative";
            }
            this.setState({ errors: errors }, () => {
                Utils.scrollToTop("taxInputBox");
            });
            return formIsValid;
        }

        if (Utils.isEmpty(fields["addLine1"])) {
            formIsValid = false;
            errors["addLine1"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("addLine1InputBox");
            });
            return formIsValid;
        }
        if (Utils.isEmpty(fields["city"])) {
            formIsValid = false;
            errors["city"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("cityInputBox");
            });
            return formIsValid;
        }
        if (Utils.isEmpty(fields["state"])) {
            formIsValid = false;
            errors["state"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("stateInputBox");
            });
            return formIsValid;
        }
        if (Utils.isEmpty(fields["zipCode"])) {
            formIsValid = false;
            errors["zipCode"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("zipCodeInputBox");
            });
            return formIsValid;
        }

        if (Utils.isEmpty(fields["phoneNumber"])) {
            formIsValid = false;
            errors["phoneNumber"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("phoneNumInputBox");
            });
            return formIsValid;
        }else if (fields["phoneNumber"].replace(/\D/g, '').length < 10) {
            // Check if the length of the numeric phone number is greater than 10
            formIsValid = false;
            errors["phoneNumber"] = "Phone number must be of 10 digits.";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("phoneNumInputBox");
            });
            return formIsValid;
        }


        if (Utils.isEmpty(fields["url"])) {
            formIsValid = false;
            errors["url"] = "Cannot be empty";
            this.setState({errors: errors}, () => {
                Utils.scrollToTop("websiteInputBox");
            });
            return formIsValid;
        }else{
            const regex = /^(https?:\/\/)?([\w\d-]+\.)*[\w\d-]+(\.[\w\d]{2,})+(\/[\w\d-]+)*\/?$/i;

            if(!regex.test(fields["url"])) {
                formIsValid = false;
                errors["url"] = "Please enter a valid website address.";
                this.setState({errors: errors}, () => {
                    Utils.scrollToTop("websiteInputBox");
                });
                return formIsValid;
            }
        }


        return formIsValid;
    }

    updateLocationFormSubmit(e){
        e.preventDefault();

        if(this.handleValidation()){

            let activeLocation = this.state.activeLocation;
            let locId = activeLocation.objectId;

            let self = this;
            self.setState({
                isLoaded : false,
                errors: {}
            });

            let fields = this.state.fields;

            let parameterObject = {};
            if (!Utils.isEmptyObj(activeLocation)) {
                // Define an array of keys that you want to update
                const keysToUpdate = ["name", "taxes", "desc", "addLine1", "addLine2", "state", "city", "zipCode", "phoneNumber", "url"];

                // Loop through the keys and update parameterObject
                keysToUpdate.forEach(key => {
                    // If the field is 'phoneNumber', format the value before updating parameterObject
                    if (key === "phoneNumber") {
                        parameterObject[key] = this.removeNonNumber(fields[key]);
                    } else if (key === "taxes") {
                        // Check if the field is 'taxes' and convert it to a number
                        parameterObject[key] = parseFloat(fields[key]);
                    } else if (key === "addLine2" && !Utils.isEmpty(fields[key])) {
                        // If addLine2 is not empty in the form, update parameterObject with its value
                        parameterObject[key] = fields[key];
                    } else {
                        // Update parameterObject with the value from the form field, or an empty string if the field is empty
                        parameterObject[key] = fields[key] || "";
                    }
                });

            }


            // add the location id in objectId key
            parameterObject["objectId"] = locId;
            this.updatePvtConfig(parameterObject);
        }
    }

    updatePvtConfig(paramsObject){
        let self = this;
        let currentUser = Parse.User.current();
        let userId = currentUser.id;
        let sessionToken = currentUser.getSessionToken();
        let businessDetail = currentUser.get("bizId");
        let bizId = businessDetail.id;

        let activeLocation = this.state.activeLocation;
        let locId = activeLocation.objectId;

        Api.updateLocation(userId, sessionToken, bizId, locId, paramsObject)
            .then(
                (result) => {
                    const response = result.data;

                    alert("Location config are updated successfully");

                    self.setState({
                        isLoaded: true
                    });

                    // Reload the data
                    self.props.reloadLocation();

                },
                (error) => {
                    Utils.checkErrorIsInvalidSessionToken(error, self.context.router);
                    this.setState({isLoaded: true});
                    console.log("Error occured while fetching latest user data!");
                }
            );

    }


    render() {
        const fields = this.state.fields;
        return (
            <div className="order-notification">
                {!this.state.isLoaded ? <Spinner/> : null}
                {
                    this.state.errors["errors"] ? (
                        <div className="alert alert-danger text-center" role="alert">
                            <span className="form-text">{this.state.errors["errors"]}</span>
                        </div>) : null

                }
                <div className="border-class marginTop">
                    <h4 id="translations" className="page-header">Update Location Settings</h4>
                    <form name="updateLocationForm" className="updateLocationForm" onSubmit= {this.updateLocationFormSubmit.bind(this)}>

                        <div className="row form-group">
                            <div className="col-lg-6" id={"locationInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName " className={"text-uppercase"}>Location Name</label>
                                    <input type="text"
                                           className="form-control"
                                           id="locationName"
                                           ref="locationName"
                                           aria-describedby="locationName"
                                           placeholder="Enter Location Name (e.g., ABC Restaurant, Valencia)"
                                           onChange={this.handleChange.bind(this, "name")}
                                           value={fields["name"] || "" }
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["name"]}</span>
                                </div>
                            </div>
                            <div className="col-lg-6"  id={"taxInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName">TAX (in percentage)</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="locationTax"
                                        ref="locationTax"
                                        aria-describedby="locationTax"
                                        placeholder="Enter Tax (e.g., 8.75)"
                                        onChange={this.updateTaxValue.bind(this, "taxes")}
                                        value={fields["taxes"]}
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["taxes"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-12"  id={"taglineInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>TAGLINE</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="tagLine"
                                        ref="tagLine"
                                       aria-describedby="tagLine"
                                        placeholder="Enter Tagline (e.g., Serving Delicious Food Since 1990)"
                                        onChange={this.handleChange.bind(this, "desc")}
                                        value={fields["desc"] || "" }
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["desc"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6" id={"addLine1InputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>Address Line 1</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="addLine1"
                                        ref="addLine1"
                                        aria-describedby="addLine1"
                                        placeholder="Enter Address Line 1 (e.g., 123 Main St)"
                                        onChange={this.handleChange.bind(this, "addLine1")}
                                        value={this.state.fields["addLine1"] || ""}
                                    />
                                    <span style={{color: "red"}} className="form-text">{this.state.errors["addLine1"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6" id={"addLine2InputBox"}>
                                <div className="form-group" >
                                    <label htmlFor="labelName" className={"text-uppercase"}>Address Line 2</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="addLine2"
                                        ref="addLine2"
                                        aria-describedby="addLine2"
                                        placeholder="Enter Address Line 2 (if applicable)"
                                        onChange={this.handleChange.bind(this, "addLine2")}
                                        value={this.state.fields["addLine2"] || ""}
                                    />

                                    <span style={{color: "red"}} className="form-text">{this.state.errors["addLine2"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6"  id={"stateInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>State</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="state"
                                        ref="state"
                                        aria-describedby="state"
                                        placeholder="Enter State (e.g., California)"
                                        onChange={this.handleChange.bind(this, "state")}
                                        value={this.state.fields["state"] || ""}
                                    />

                                    <span style={{color: "red"}} className="form-text">{this.state.errors["state"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6"  id={"zipCodeInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>Zip code</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="zipCode"
                                        ref="zipCode"
                                        aria-describedby="zipCode"
                                        placeholder="Enter Zip Code (e.g., 12345)"
                                        onChange={this.handleChange.bind(this, "zipCode")}
                                        value={this.state.fields["zipCode"] || ""}
                                    />

                                    <span style={{color: "red"}} className="form-text">{this.state.errors["zipCode"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6" id={"cityInputBox"}>
                                <label htmlFor="labelName" className={"text-uppercase"}>City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="city"
                                    ref="city"
                                    aria-describedby="city"
                                    placeholder="Enter City (e.g., Los Angeles)"
                                    onChange={this.handleChange.bind(this, "city")}
                                    value={this.state.fields["city"] || ""}
                                />

                                <span style={{color: "red"}} className="form-text">{this.state.errors["city"]}</span>
                            </div>


                            <div className="col-lg-6"  id={"phoneNumInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>Phone Number</label>

                                    <input
                                        type="tel"
                                        className="form-control"
                                        id="phoneNumber"
                                        ref="phoneNumber"
                                        aria-describedby="phoneNumber"
                                        placeholder="Enter Phone Number (e.g., (123) 456-7890)"
                                        onChange={this.updatePhoneNumber}
                                        value={this.state.fields["phoneNumber"] || ""}
                                        maxLength="14"
                                        onKeyPress={this.handleKeyPress}
                                    />

                                    <span style={{color: "red"}} className="form-text">{this.state.errors["phoneNumber"]}</span>
                                </div>
                            </div>

                            <div className="col-lg-6" id={"websiteInputBox"}>
                                <div className="form-group">
                                    <label htmlFor="labelName" className={"text-uppercase"}>Website</label>

                                    <input
                                        type="text"
                                        className="form-control"
                                        id="website"
                                        ref="website"
                                        aria-describedby="website"
                                        placeholder="Example: www.example.com"
                                        onChange={this.handleChange.bind(this, "url")}
                                        value={this.state.fields["url"] || ""}
                                    />

                                    <span style={{color: "red"}} className="form-text">{this.state.errors["url"]}</span>
                                </div>
                            </div>

                        </div>


                        <hr></hr>

                        <div className="form-group">
                            <button type="submit" className="btn btn-export">Save</button>
                            <button type="button" className="btn btn-default back-button"
                                    onClick={_ => this.props.reloadLocation()}>Cancel
                            </button>
                        </div>
                        <hr></hr>

                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// src/components/location/location-config.js